var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-chain"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 5.50341L1.70713 5.50341L6.3536 0.856992C6.5508 0.663758 6.55398 0.347234 6.36074 0.150033C6.16745 -0.0471689 5.85092 -0.0504037 5.65372 0.142892C5.65134 0.145211 5.64896 0.147591 5.64658 0.150033L0.146665 5.64995C-0.0486441 5.84501 -0.0489493 6.16129 0.146116 6.3566C0.146238 6.35679 0.14636 6.35691 0.146665 6.35691L5.64658 11.8568C5.84378 12.0501 6.16031 12.0469 6.35354 11.8497C6.54409 11.6553 6.54409 11.3442 6.35354 11.1498L1.70713 6.50339L11.5 6.50339C11.7761 6.50339 12 6.27952 12 6.0034C12 5.72728 11.7761 5.50341 11.5 5.50341Z",
    fill: "#0A0A0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.23fa86a51f176e7df2cb3ce60ea55b82.svg";
export { ForwardRef as ReactComponent };